import LoadingUtil from '../../core/util/loading_util';
import { VariationsAttrModel } from '../models/variations_attr_model';
import { VariationsCategoryModel } from '../models/variations_category_model';
import { VariationAction } from './variation_action';
import TableTooltipAction from './table_tooltip_action';

export default class FilterVariationsAction {
  // static SEND_USEFULNESS = new TypedEvent<FeedBackModel>();
  private static deleteSubCategories(idToDel: string) {
    let e: Element | null = document.getElementById(idToDel);
    if (e && e.previousElementSibling?.tagName === 'p') {
      (e.previousElementSibling as HTMLParagraphElement).style.display = 'none';
    }
    while (e) {
      if (e && e.previousElementSibling?.tagName === 'div') {
        (e as HTMLDivElement).style.display = 'none';
      }
      e = e.nextElementSibling;
    }
  }

  static deleteCategory = (e: Event, model: VariationsCategoryModel) => {
    // デフォルの動き防止
    e.stopImmediatePropagation();
    FilterVariationsAction.deleteSubCategories(model.id);

    console.log('delete ', model);
    const url = new URL(window.location.href);
    url.searchParams.delete(model.urlKey);

    switch (model.urlKey) {
      case 'categoryLl':
        url.searchParams.delete('categoryL');
        url.searchParams.delete('categoryM');
        url.searchParams.delete('categoryS');
        break;
      case 'categoryL':
        url.searchParams.delete('categoryM');
        url.searchParams.delete('categoryS');
        break;
      case 'categoryM':
        url.searchParams.delete('categoryS');
        break;
      default:
    }

    LoadingUtil.asyncPage(url.toString()).then((newDoc) =>
      VariationAction.REFRESH_TABLE.trigger(newDoc)
    );
  };

  static deleteAttr = (model: VariationsAttrModel, event: Event) => {
    console.log('delete ', model);
    const url = new URL(window.location.href);
    const paramsKeep = url.searchParams
      .getAll(model.urlKey)
      .filter((param) => param !== model.originalUrlParameter);
    // delete all
    url.searchParams.delete(model.urlKey);
    paramsKeep.forEach((param) => {
      url.searchParams.append(model.urlKey, param);
    });
    const target = event.currentTarget as HTMLElement;
    LoadingUtil.asyncPage(url.toString()).then((newDoc) => {
      VariationAction.REFRESH_TABLE.trigger(newDoc);
      TableTooltipAction.SEND_VARIATION_SEARCH_EVENT.trigger({
        linkName: 'vrSearchPjax',
        target: target
      });
    });
  };
}
